module.exports = "./img/9ce81b053b5e8b5e066ba36c7c2a39d1.jpg";